<template>
    <div>
        <div>
            <TableList
                ref="table-list"
                :title="''"
                :columns="columns"
                :rows="groupData"
                :keyField="'sysNodeIdx'"
                :toggleFields="['enabled']"
                :transCodes="transCodes"
                :controls="controls"
                :useFilter="false"
                :mode="'edit'"
                @button-click="handleListButtonClick"
                @toggle-changed="handleItemToggle"
            />
            <!-- 클릭이벤트 방지 -->
            <!-- @row-click="handleListItemClick" -->

            <!-- @row-click="handleListItemClick" -->
            <SubGroupModal ref="SubGroupModal" :data="data" @save="addSubGroup" />
            <AddNodeModal ref="AddNodeModal" :node="data" :routeType="$route.params.type" @save="AddSysNode" />
        </div>
    </div>
</template>

<script>
import backEndApi from "@src/api/backEndApi";
import TableList from "@src/views/component/v2.1/ListDetailView/TableList.vue";
import SubGroupModal from "../modal/SubGroupModal.vue";
import AddNodeModal from "../modal/AddNodeModal.vue";
import * as popupMessages from "@src/consts/popupMessageConsts";

export default {
    components: {
        TableList,
        SubGroupModal,
        AddNodeModal,
    },
    props: ["data"],
    data() {
        return {
            rows: [],
            columns: [
                {
                    label: "노드 ID",
                    field: "sysNodeIdx",
                    type: "text",
                    // compositionFields: ['sysNodeName', 'sysNodeIdx'],
                    thClass: "text-center",
                    tdClass: "text-center font-weight-bold text-dark",
                },
                {
                    label: "노드명",
                    field: "sysNodeName",
                    type: "text",
                    // compositionFields: ['sysNodeName', 'sysNodeIdx'],
                    thClass: "text-center",
                    tdClass: "text-center font-weight-bold text-dark",
                },
                {
                    label: "노드 유형",
                    field: "nodeType",
                    type: "text",
                },
                {
                    label: "계통 유형",
                    field: "sysType",
                    type: "text",
                },
                {
                    label: "설비 유형",
                    field: "equipType",
                    type: "text",
                },
                {
                    label: "구역",
                    field: "zoneIdx",
                    type: "text",
                },
                {
                    label: "사용여부",
                    field: "enabled",
                    type: "text",
                },
            ],
            transCodes: [
                {
                    field: "nodeType",
                    codes: this.$store.state.commonCodes.nodeType,
                },
                {
                    field: "sysType",
                    codes: this.$store.state.transSysType,
                },
                {
                    field: "equipType",
                    codes: this.$store.state.transEquipType,
                },
                {
                    field: "zoneIdx",
                    codes: this.$store.state.zoneInfo,
                },
                {
                    field: "enabled",
                    codes: this.$store.state.commonCodes.enabled,
                },
            ],
            controls: [
                { event: "delete", label: "-", class: "btn-danger" },
                { event: "status", label: "사용", class: "bg-white text-dark", options: { enabled: "Y" } },
                { event: "status", label: "미사용", class: "bg-white text-dark", options: { enabled: "N" } },
                { event: "regist", label: "+", class: "btn-primary" },
            ],
            groupData: null,
            rowIdx: null,
            sysType: null,
            popupMessages,
        };
    },
    computed: {},
    watch: {},
    created() {},
    mounted() {},
    beforDestroyed() {},
    methods: {
        setGroupData(node) {
            this.groupData = null;

            let checkGroupNode = node.subNodes.some((item) => item.nodeType == "Group");

            if (checkGroupNode) {
                this.groupData = node.subNodes.filter((item) => item.nodeType == "Group");
            } else {
                this.groupData = [];
            }
        },
        async handleListButtonClick(event, options) {
            const that = this;

            switch (event) {
                case "regist":
                    // await that.registNew();
                    await that.openAddModal("Group");
                    break;

                case "delete":
                    await that.deleteChecked();
                    break;

                // case 'refresh':
                //     await that.getDataList(event);
                //     break;

                case "status":
                    await that.changeStatusChecked(options);
                    break;

                default:
                    console.warn("Unhandled Component Event. event:", event, "options:", options);
                    break;
            }
        },
        async handleItemToggle(key, field, status) {
            await this.changeStatus(key, field, status);
        },
        async changeStatus(key, field, status) {
            // console.log(`key: ${key}, field: ${field}, status: ${status}`);
            const data = {};
            data["sysNodeIdx"] = key;
            data[field] = status;

            try {
                let result = await backEndApi.sysNode.setEnabled(data);
                if (result.status == 200) {
                    await this.alertNoti(popupMessages.COMMON_STATUS_CHANGE_SUCCESS_POPUP_MESSAGE);
                } else {
                    this.alertWarning(
                        `${result.data.message}`,
                        "",
                        `${typeof result.data.detail == "string" ? result.data.detail : ""}`
                    );
                }
            } catch (e) {
                console.error(e);
            }
        },
        async changeStatusChecked(options) {
            const that = this;

            let data = options;

            try {
                const checked = this.$refs["table-list"].getCheckedRows();
                if (!that.isEmpty(checked)) {
                    checked.forEach(async (item) => {
                        if (!that.isEmpty(data)) {
                            data["sysNodeIdx"] = item.sysNodeIdx;

                            if (data.hasOwnProperty("enabled")) {
                                await backEndApi.sysNode.setEnabled(data);
                            } else {
                                console.warn("Unknown Status Name");
                            }
                        }
                    });
                    await this.alertNoti(popupMessages.COMMON_STATUS_CHANGE_SUCCESS_POPUP_MESSAGE);
                    await this.$emit("refresh", this.data.sysNodeIdx);
                } else {
                    this.alertNoti(popupMessages.COMMON_STATUS_CHANGE_NOTI_POPUP_MESSAGE);
                }
            } catch (e) {
                console.error(e);
                this.alertNoti(popupMessages.COMMON_STATUS_CHANGE_ERROR_POPUP_MESSAGE);
            }
        },

        async handleListItemClick(row, index, toggle, check) {
            const that = this;
            if (toggle || check) return;
            that.rowIdx = index;
            const find = this.groupData.find((item) => item.sysNodeName == row.sysNodeName);
            await that.$refs.SubGroupModal.setData({ ...find });
            await this.$refs.SubGroupModal.showSubGroupModal();
        },
        async registNew() {
            this.rowIdx = null;
            await this.$refs.SubGroupModal.setData(null, this.data.sysType);
            await this.$refs.SubGroupModal.showSubGroupModal();
        },
        addSubGroup() {
            let group = this.$refs.SubGroupModal.subGroupData;

            if (group) {
                // this.$set(this.data, this.data.length, addGroup)
                if (this.rowIdx !== null || undefined) {
                    this.$set(this.groupData, this.rowIdx, group);
                } else {
                    let duplicate = this.groupData.find((item) => item.sysNodeName == group.sysNodeName);
                    if (duplicate) {
                        this.alertNoti(popupMessages.SYSTEM_EQUIP_DUPLICATE_NODE_MESSAGE);
                        return;
                    } else {
                        this.$set(this.groupData, this.groupData.length, group);
                    }
                }
            }
            console.log("addSubGroup", this.data.sysNodeIdx);
            this.$emit("refresh", this.data.sysNodeIdx);
        },
        async deleteChecked() {
            const that = this;

            try {
                let confirm = await this.alertConfirmWarning(popupMessages.COMMON_DELETE_CONFIRM_POPUP_MESSAGE);
                if (!confirm.value) return;

                const checked = this.$refs["table-list"].getCheckedRows();
                if (!that.isEmpty(checked)) {
                    checked.forEach(async (item) => {
                        await backEndApi.sysNode.deleteSysNode(item.sysNodeIdx);
                    });
                    await this.alertNoti(popupMessages.COMMON_DELETE_POPUP_MESSAGE);
                    this.$emit("refresh", this.data.sysNodeIdx);
                } else {
                    this.alertNoti(popupMessages.COMMON_DELETE_NOTI_POPUP_MESSAGE);
                }
            } catch (e) {
                this.alertNoti(popupMessages.COMMON_REMOVE_ERROR_POPUP_MESSAGE);
                console.error(e);
            }
        },
        async openAddModal(nodeType) {
            // this.$nextTick(async () => {
            //     if (!this.currentNode) this.alertNoti("노드를 선택해주세요.")
            //     else {
            //         await this.$refs.AddNodeModal.initData();
            //         await this.$refs.AddNodeModal.showAddNodeModal();
            //     }
            // })
            await this.$refs.AddNodeModal.initData(nodeType);
            await this.$refs.AddNodeModal.showAddNodeModal();
        },
        async AddSysNode(nodeInfo, sysNodeIdx, sumAvail) {
            let newNode = {
                nodeType: nodeInfo.nodeType,
                sysNodeName: nodeInfo.sysNodeName,
                sysType: nodeInfo.sysType,
                equipType: nodeInfo.equipType,
                mainNodeIdx: sysNodeIdx,
            };
            if (sumAvail == "Y") {
                newNode = {
                    ...newNode,
                    sumEnabled: nodeInfo.sumEnabled,
                    sumUnitType: nodeInfo.sumUnitType,
                    sumUnit: nodeInfo.sumUnit,
                    sumCondType: nodeInfo.sumCondType,
                    sumCond: nodeInfo.sumCond,
                    sumMethod: nodeInfo.sumMethod,
                };
            }
            try {
                let result = await backEndApi.sysNode.addSysNode(newNode);
                if (result.status == 200) {
                    await this.alertNoti(popupMessages.COMMON_SAVE_POPUP_MESSAGE);
                    await this.$refs.AddNodeModal.hideAddNodeModal();
                    await this.$emit("refresh", this.data.sysNodeIdx);
                    // await this.$refs['tree-detail'].clearData();
                } else {
                    // let detail = "";
                    // if (result.data.errcode) await this.alertWarning(result.data.message);
                    // else {
                    //     result.data.detail.forEach((item) => (detail += item));
                    //     await this.alertWarning(result.data.message, "", detail);
                    // }
                    this.alertWarning(
                        `${result.data.message}`,
                        "",
                        `${typeof result.data.detail == "string" ? result.data.detail : ""}`
                    );
                }
            } catch (e) {
                console.error(e);
            }
        },
    },
};
</script>
